import { render, staticRenderFns } from "./aMap.vue?vue&type=template&id=c8804bb6&"
import script from "./aMap.vue?vue&type=script&lang=ts&"
export * from "./aMap.vue?vue&type=script&lang=ts&"
import style0 from "./aMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports